import script from "./TotalAssignedDataComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalAssignedDataComponent.vue?vue&type=script&setup=true&lang=js"

import "./TotalAssignedDataComponent.vue?vue&type=style&index=0&id=5723356c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5723356c"]])

export default __exports__